import React from 'react';
import { StarIcon } from 'lucide-react';
import { testimonials } from '../data/testimonials';
import { Reveal } from './Reveal';
import { SectionHeading } from './SectionHeading';
function Stars() {
  return <div className="flex gap-0.5" aria-hidden="true" data-id="element-178" data-mp="1n0txn3uxxrda">
      {[1, 2, 3, 4, 5].map(star => <StarIcon key={star} className="h-3.5 w-3.5 fill-[#E8B02B] text-[#E8B02B]" data-id="element-179" data-mp="1r0uaik2e5ui8" />)}
    </div>;
}
export function TestimonialsSection() {
  return <section className="bg-tr-cream px-5 py-14 md:py-24" data-id="element-180" data-mp="1i1h11re9p5xi">
      <Reveal className="mx-auto max-w-container" data-id="element-181" data-mp="1hyusppjjyme8">
        <SectionHeading eyebrow="Trusted by coaches" title="What Tennis Coaches Are Saying." data-id="element-182" data-mp="141y7q4q47z59" />
        <div className="mt-5 flex items-center justify-center gap-2 text-[13px] text-tr-grey" data-id="element-183" data-mp="1839yidkq6qf1">
          <Stars data-id="element-184" data-mp="2ygikzwc3wsem" />
          Rated 5 stars by coaches and teachers worldwide.
        </div>
        <div className="mt-12 grid gap-5 sm:grid-cols-2 lg:grid-cols-3" data-id="element-185" data-mp="32frbmsbuoa5y">
          {testimonials.map(testimonial => <article key={testimonial.quote} className="flex flex-col rounded-card border border-tr-border bg-white p-7 text-left shadow-card" data-id="element-186" data-mp="2uzrkd6oxdlmp">
              <Stars data-id="element-187" data-mp="34qujw427hsjv" />
              <p className="mt-4 flex-1 text-[15px] leading-relaxed text-tr-navy" data-id="element-188" data-mp="34tgp3x1mjvyx">
                {testimonial.quote}
              </p>
              <div className="mt-6" data-id="element-189" data-mp="2c26sdqqv66xv">
                <p className="text-sm font-bold text-tr-navy" data-id="element-190" data-mp="2c38h2y0syry2">
                  {testimonial.name}
                </p>
                <p className="mt-0.5 text-xs text-tr-grey" data-id="element-191" data-mp="275q6l37504ny">{testimonial.role}</p>
              </div>
            </article>)}
        </div>
      </Reveal>
    </section>;
}